module.exports = __webpack_public_path__ + "img/DIO2000&3000.def23b81.png";